export default {
  resorder_issues: "مشاكل الطلبات",
  resno_delivered_orders: "لا توجد طلبات تم تسليمها",
  resreport_view: "إبلاغ / عرض",
  ressupplier: "المورد",

  status_delivered: "تم التسليم",
  status_placed: "تم الطلب",
  status_pending: "قيد الانتظار",
  status_cancelled: "تم الإلغاء",
  status_under_review: "قيد المراجعة",
  status_issue_resolved: "تم حل المشكلة",
  status_acknowledged: "تم الاستلام",
  status_rejected: "مرفوض"
};